<li
  class="cursor-pointer border-l border-grey-300 px-md py-xs text-president-400"
  [ngClass]="{'border-l-2 border-primary text-primary': active}"
  (click)="scrollToElement()"
>
  <span [class.-ml-px]="active">
    <ng-content></ng-content>
  </span>
</li>
